"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStudioUrl = exports.STUDIO_HASH_CHANGE_EVENT = void 0;
const parse_1 = require("lib/url/parse");
const route_1 = require("lib/url/route");
const helpers_1 = require("lib/helpers");
// updateAppUrl's own "did the URL actually change" check compares pathname + query only,
// never the hash — so a same-page hash change (e.g. clearing #id-verification) looks like
// a no-op to it and gets silently skipped. We handle that one case ourselves below, and
// notify listeners (NavigationContext) via this event since it bypasses Next's router.
exports.STUDIO_HASH_CHANGE_EVENT = 'studio-hash-change';
// Shared by every Studio app (artworks, sales, address, promotions, ...) and the Studio nav.
// Masks the real Next.js page/query (`page` + `params`) behind a clean `href` in the address bar,
// and updates the URL before the client-side transition starts to avoid a race where the Redux
// store gets built against the previous page's URL (see `updateAppUrl` in lib/url/route.ts).
const updateStudioUrl = ({ page, href, params = {}, scroll = false, }) => {
    if (typeof window !== 'undefined') {
        const [targetPath] = href.split('#');
        const currentPath = `${window.location.pathname}${window.location.search}`;
        if (targetPath === currentPath) {
            history.replaceState(history.state, '', href);
            window.dispatchEvent(new Event(exports.STUDIO_HASH_CHANGE_EVENT));
            if (scroll) {
                const [, hash] = href.split('#');
                const target = hash ? document.getElementById(hash) : null;
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                else {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            }
            return;
        }
    }
    const { query } = (0, parse_1.parse)(href) || {};
    const app = `${page}?${(0, helpers_1.objectToQueryString)(Object.assign(Object.assign({}, params), query))}`;
    (0, route_1.updateAppUrl)({ app, href, scroll });
};
exports.updateStudioUrl = updateStudioUrl;
